import { Box, Dialog, Portal } from '@chakra-ui/react';
import { useCreateCryptoWhitelist } from 'hooks';
import { useTranslation } from 'localization';
import { TransactionMethodKey } from 'types';

import {
  ServiceDialogBody,
  ServiceDialogCloseTrigger,
  ServiceDialogHeader,
  serviceDialogShellProps,
} from '../ServiceDialog';

import { AddCrypto } from './components';

type PayloadType = {
  title?: string;
  wallet_address: string;
};

type AddCryptoWhitelistType = {
  wallet: string;
  transaction_method: { id: string; key: TransactionMethodKey | '' };
  onClose: () => void;
  onSuccess: () => void;
  isOpen: boolean;
};

const AddCryptoWhitelist: React.FC<AddCryptoWhitelistType> = ({
  wallet,
  onClose,
  onSuccess,
  isOpen,
  transaction_method,
}: AddCryptoWhitelistType) => {
  const { t } = useTranslation('component.withdraw.crypto.initModal');

  const { mutateAsync: submit } = useCreateCryptoWhitelist();

  const onSubmit = async (data: PayloadType) => {
    submit({ ...data, wallet, transaction_method: transaction_method.id }).then(
      () => {
        onSuccess();
        onClose();
      }
    );
  };

  return (
    <Box>
      <Dialog.Root
        size="xl"
        open={isOpen}
        placement="center"
        onOpenChange={(e: { open: boolean }) => {
          if (!e.open) {
            onClose();
          }
        }}
      >
        <Portal>
          <Dialog.Backdrop />
          <Dialog.Positioner>
            <Dialog.Content {...serviceDialogShellProps({ maxW: 'xl' })} px={0}>
              <ServiceDialogHeader>{t('modalTitle')}</ServiceDialogHeader>
              <ServiceDialogCloseTrigger />
              <ServiceDialogBody px={0} py={4}>
                <AddCrypto
                  onSubmit={async (data) => onSubmit(data)}
                  trMethodKey={transaction_method.key}
                />
              </ServiceDialogBody>
            </Dialog.Content>
          </Dialog.Positioner>
        </Portal>
      </Dialog.Root>
    </Box>
  );
};

export default AddCryptoWhitelist;
